import { useEffect, useState } from "react";
import { CLOSING_DISCLOSURE, HUD_1, REFINANCE } from "utils/constants";

interface Params {
  orderType: string;
  transactionType: string;
}

const getInitialTab = (orderType: string, transactionType: string) => {
  if (orderType === HUD_1) return "J-K";
  if (orderType === CLOSING_DISCLOSURE && transactionType === REFINANCE) return "A";

  return "A";
};

export const useCharges = ({
  orderType,
  transactionType
}: Params) => {
  const [currentChargeTabSelected, setCurrentChargeTabSelected] = useState<string>(getInitialTab(orderType,
    transactionType));

  useEffect(() => {
    setCurrentChargeTabSelected(getInitialTab(orderType,
      transactionType));
  }, [orderType, transactionType]);

  const handleSelectKindTab = (kind: string) => {
    setCurrentChargeTabSelected(kind);
  };

  return {
    currentChargeTabSelected,
    handleSelectKindTab
  };
};